/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeFromJSON, FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeToJSON, } from './FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType';
import { FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSON, FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSON, } from './FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownload';
import { FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentFromJSON, FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentToJSON, } from './FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrent';
/**
 * Check if a given object implements the FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifact interface.
 */
export function instanceOfFtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifact(value) {
    if (!('SourceBuildNumber' in value) || value['SourceBuildNumber'] === undefined)
        return false;
    if (!('DestinationBuildNumber' in value) || value['DestinationBuildNumber'] === undefined)
        return false;
    if (!('Torrent' in value) || value['Torrent'] === undefined)
        return false;
    if (!('HttpDownload' in value) || value['HttpDownload'] === undefined)
        return false;
    if (!('ManifestUrl' in value) || value['ManifestUrl'] === undefined)
        return false;
    if (!('ManifestSha256' in value) || value['ManifestSha256'] === undefined)
        return false;
    if (!('PatchSize' in value) || value['PatchSize'] === undefined)
        return false;
    if (!('FullSize' in value) || value['FullSize'] === undefined)
        return false;
    if (!('MaxFileSize' in value) || value['MaxFileSize'] === undefined)
        return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('Type' in value) || value['Type'] === undefined)
        return false;
    return true;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactFromJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactFromJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SourceBuildNumber': json['sourceBuildNumber'],
        'DestinationBuildNumber': json['destinationBuildNumber'],
        'Torrent': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentFromJSON(json['torrent']),
        'HttpDownload': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadFromJSON(json['httpDownload']),
        'ManifestUrl': json['manifestUrl'],
        'ManifestSha256': json['manifestSha256'],
        'PatchSize': json['patchSize'],
        'FullSize': json['fullSize'],
        'MaxFileSize': json['maxFileSize'],
        'CreatedAt': (new Date(json['createdAt'])),
        'Type': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeFromJSON(json['type']),
    };
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactToJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactToJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sourceBuildNumber': value['SourceBuildNumber'],
        'destinationBuildNumber': value['DestinationBuildNumber'],
        'torrent': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultTorrentToJSON(value['Torrent']),
        'httpDownload': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultHttpDownloadToJSON(value['HttpDownload']),
        'manifestUrl': value['ManifestUrl'],
        'manifestSha256': value['ManifestSha256'],
        'patchSize': value['PatchSize'],
        'fullSize': value['FullSize'],
        'maxFileSize': value['MaxFileSize'],
        'createdAt': ((value['CreatedAt']).toISOString()),
        'type': FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeToJSON(value['Type']),
    };
}
//# sourceMappingURL=FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifact.js.map